import React from 'react';
import styled from 'styled-components';

// Match the exact wrapper from LandingPageGallery with fade out animation
const CarouselWrapper = styled.div`
  max-width: 100%;
  margin-top: ${({ theme }) => theme.space.xxl};
  margin-bottom: ${({ theme }) => theme.space.l};
  transition: opacity 0.3s ease-out;
`;

// Reusable skeleton pulse component with the same wave effect as PlannerSkeleton
const SkeletonPulse = styled.div`
  position: relative;
  overflow: hidden;
  background-color: #e5e7eb;
  border-radius: 4px;

  &::after {
    content: '';
    position: absolute;
    inset: 0;
    transform: translateX(-100%) skewX(-15deg);
    background: linear-gradient(
      90deg,
      transparent 0%,
      rgb(255 255 255 / 10%) 25%,
      rgb(255 255 255 / 60%) 50%,
      rgb(255 255 255 / 10%) 75%,
      transparent 100%
    );
    animation: wave 2.2s cubic-bezier(0.4, 0, 0.2, 1) 0.5s infinite;
  }

  @keyframes wave {
    0% {
      transform: translateX(-100%) skewX(-15deg);
    }

    60% {
      transform: translateX(100%) skewX(-15deg);
    }

    100% {
      transform: translateX(100%) skewX(-15deg);
    }
  }
`;

const SkeletonContainer = styled.div`
  display: flex;
  gap: 1.25rem;
  overflow: hidden;
`;

const SkeletonItem = styled.div`
  display: flex;
  flex-direction: column;
  width: 200px;
  flex-shrink: 0;
`;

const SkeletonImage = styled(SkeletonPulse)`
  width: 200px;
  height: 200px;
  margin-bottom: 8px;
`;

const SkeletonText = styled(SkeletonPulse)`
  height: 16px;
  width: 120px;
  margin-bottom: 8px;
`;

const SkeletonPrice = styled(SkeletonPulse)`
  height: 24px;
  width: 80px;
`;

const SkeletonTitle = styled(SkeletonPulse)`
  margin-top: 1.5rem;
  height: 32px;
  width: 250px;
  margin-bottom: 26px;
`;

export const GallerySkeleton: React.FC = () => {
  // Create skeleton items with fixed count
  const skeletonItems = Array.from({ length: 7 }, (_, i) => (
    <SkeletonItem key={i}>
      <SkeletonImage />
      <SkeletonText />
      <SkeletonPrice />
    </SkeletonItem>
  ));

  return (
    <CarouselWrapper>
      <SkeletonTitle />
      <SkeletonContainer>{skeletonItems}</SkeletonContainer>
    </CarouselWrapper>
  );
};
